/* unplugin-vue-components disabled */import { render } from "./UserLoginView.vue?vue&type=template&id=43ca70f1"
import script from "./UserLoginView.vue?vue&type=script&lang=js"
export * from "./UserLoginView.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__